import * as React from 'react'
import { memo } from 'react'
const SvgLinkedin = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
  >
    <path d="M3.582 15.999H.264V5.317h3.318ZM1.921 3.86a1.93 1.93 0 1 1 1.921-1.939A1.937 1.937 0 0 1 1.921 3.86ZM16 15.999h-3.31v-5.2c0-1.239-.025-2.829-1.725-2.829-1.725 0-1.989 1.346-1.989 2.739v5.29H5.659V5.317h3.182v1.457h.046a3.486 3.486 0 0 1 3.139-1.725C15.383 5.049 16 7.26 16 10.132v5.867Z" />
  </svg>
)
const Memo = memo(SvgLinkedin)
export default Memo
